import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Select, Option, Input, Button } from "@mui/joy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postFetch } from "../../../../../fetch/fetch";

/**
 * 윈터스쿨 설명회 신청자 관리 > '수동 추가하기' 팝업 — 회차 select + 학년 select + 이름 + 전화번호 → POST /dashboard/winterPresentation/manual
 * 서버가 isManual = 1 로 저장하고 저장된 행을 돌려주면 부모(onSuccess)가 목록 맨 위에 넣는다.
 * props: open, onClose, sessions({ round, label }[]), grades(string[]), onSuccess(row)
 */

const toastOptions: any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored",
};

const WinterPresentationManualAddModal: React.FC<any> = (props) => {

    const [round, setRound] = useState<number>(0);
    const [grade, setGrade] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("010");
    const [loading, setLoading] = useState<boolean>(false);

    // 모달 열릴 때 입력값 초기화
    useEffect(() => {
        if (props.open) {
            setRound(0);
            setGrade("");
            setName("");
            setPhoneNumber("010");
            setLoading(false);
        }
    }, [props.open]);

    const digits = phoneNumber.replace(/[^0-9]/g, "");
    const canSubmit = round > 0 && !!grade && name.trim().length > 0 && digits.length >= 10 && digits.length <= 11;

    const submit = async () => {
        if (!canSubmit || loading) return;
        try {
            setLoading(true);
            const result: any = await postFetch("/dashboard/winterPresentation/manual", {
                round,
                grade,
                name: name.trim(),
                phoneNumber: digits,
            });
            if (result.message === "success" && result.data) {
                toast.success(`${result.data.name} 신청을 추가했습니다`, toastOptions);
                props.onSuccess && props.onSuccess(result.data);
                props.onClose && props.onClose();
            } else {
                console.log(result);
                toast.error("추가에 실패했습니다. 다시 시도해 주세요.", toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("추가에 실패했습니다. 다시 시도해 주세요.", toastOptions);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={!!props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "300px" }}>
                    <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "6px" }}>
                        수동 추가하기
                    </div>
                    <div style={{ fontSize: "13px", color: "#6B7684", marginBottom: "18px" }}>
                        일별 추이 그래프에는 합산되지 않습니다.
                    </div>

                    <div style={{ fontSize: "13px", marginBottom: "6px" }}>회차</div>
                    <Select
                        placeholder="회차 선택"
                        value={round || null}
                        onChange={(e, value) => setRound(value ? +value : 0)}
                        sx={{ marginBottom: "14px" }}
                    >
                        {(props.sessions || []).map((s: any) => (
                            <Option key={s.round} value={s.round}>{s.label}</Option>
                        ))}
                    </Select>

                    <div style={{ fontSize: "13px", marginBottom: "6px" }}>학년</div>
                    <Select
                        placeholder="학년 선택"
                        value={grade || null}
                        onChange={(e, value) => setGrade(value ? String(value) : "")}
                        sx={{ marginBottom: "14px" }}
                    >
                        {(props.grades || []).map((g: string) => (
                            <Option key={g} value={g}>{g}</Option>
                        ))}
                    </Select>

                    <div style={{ fontSize: "13px", marginBottom: "6px" }}>이름</div>
                    <Input
                        placeholder="이름"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{ marginBottom: "14px" }}
                    />

                    <div style={{ fontSize: "13px", marginBottom: "6px" }}>전화번호</div>
                    <Input
                        placeholder="01012345678"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))}
                        onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
                    />

                    <div style={{ marginTop: "25px", display: "flex", gap: "8px" }}>
                        <Button variant="outlined" color="neutral" fullWidth onClick={props.onClose} disabled={loading}>
                            취소
                        </Button>
                        <Button variant="solid" fullWidth onClick={submit} loading={loading} disabled={!canSubmit}>
                            등록하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default WinterPresentationManualAddModal;
